module.exports = __webpack_public_path__ + "img/binance.0857a11b.svg";